export default __webpack_public_path__ + "static/media/Suzuki.c3d02ca3.jpg";